import { getDatadogRumConfig } from './datadog-rum-config';

let initialized = false;

export const initializeDatadogRum = async (): Promise<void> => {
  if (initialized) {
    return;
  }

  const config = getDatadogRumConfig();

  if (!config) {
    return;
  }

  try {
    const { datadogRum } = await import('@datadog/browser-rum');

    datadogRum.init(config);

    initialized = true;
  } catch {
    // Observability must not block the application from starting.
  }
};
